import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98f85e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Your Upcoming Destinations", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This exercise could be solved in one billion ways: "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://frontendmasters.com/courses/vue-3/components-solution/"
  }, "Sarah's solution")
], -1))
const _hoisted_3 = { class: "location-contain" }
const _hoisted_4 = ["src"]

import singleDestination from '../components/SlotsExerciseSingleDestination.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const locations = [
        {
          name: 'moscow',
          img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/28963/moscow.svg',
          desc: `Moscow is the capital and most populous city of Russia, with 13.2 million residents within the city limits and 17.8 million within the urban area. Moscow has the status of a Russian federal city.`
        },
        {
          name: 'paris',
          img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/28963/paris1.svg',
          desc: `Paris is the capital and most populous city of France. By the 17th century, Paris was one of Europe's major centres of finance, commerce, fashion, science, and the arts, and it retains that position still today.`
        },
        {
          name: 'rome',
          img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/28963/rome.svg',
          desc: `Rome's history spans more than 2,500 years. While Roman mythology dates the founding of Rome at around 753 BC, the site has been inhabited for much longer, making it one of the oldest continuously occupied sites in Europe.`
        },
        {
          name: 'paris',
          img: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/28963/paris2.svg',
          desc: `By the end of the 12th century, Paris had become the political, economic, religious, and cultural capital of France. Maurice de Sully undertook the construction of the Notre Dame Cathedral at its eastern extremity.`
        }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(locations, (location) => {
        return _createVNode(singleDestination, { key: location }, {
          image: _withCtx(() => [
            _createElementVNode("img", {
              src: location.img,
              width: "235",
              height: "300"
            }, null, 8, _hoisted_4)
          ]),
          city: _withCtx(() => [
            _createElementVNode("h2", null, _toDisplayString(location.name), 1)
          ]),
          description: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(location.desc), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ])
  ]))
}
}

})